/** Optional server capabilities never grant record or reviewer permissions. */
export type ControlCapability = 'departure_control' | 'reviewer_navigation' | 'request_client_price_reminders';
export function controlCapabilityEnabled(value: unknown, capability: ControlCapability, production: boolean): boolean {
  if (!production) return true;
  return value !== null && typeof value === 'object' && !Array.isArray(value)
    && Object.prototype.hasOwnProperty.call(value, capability)
    && (value as Record<string, unknown>)[capability] === true;
}
